export default {
  title: 'Ricevi notizie e offerte via e-mail',
  form: {
    marketing_subscription: {
      label: 'Ricevi offerte esclusive, sconti e aggiornamenti direttamente nella tua casella di posta',
    },
  },
};
